import { render, staticRenderFns } from "./DentForm.vue?vue&type=template&id=6a23eb6e&"
import script from "./DentForm.vue?vue&type=script&lang=js&"
export * from "./DentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports